import { PostgrestError } from '@supabase/supabase-js';

interface DatabaseError extends Error {
  code?: string;
  details?: string;
  hint?: string;
  message: string;
}

export function isDatabaseError(error: unknown): error is DatabaseError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    'message' in error
  );
}

export function isPostgrestError(error: unknown): error is PostgrestError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    'message' in error &&
    'details' in error &&
    'hint' in error
  );
}

export const DATABASE_ERROR_CODES = {
  MISSING_CONTRACTOR_SUBPROJECT: 'SY001',
} as const;

export function getDatabaseErrorKey(error: unknown): string | null {
  if (!isDatabaseError(error)) {
    return null;
  }

  switch (error.code) {
    case DATABASE_ERROR_CODES.MISSING_CONTRACTOR_SUBPROJECT:
      return 'database_errors.missing_contractor_subproject';
    default:
      return null;
  }
}

export function logDatabaseError(error: unknown): void {
  if (isPostgrestError(error)) {
    // eslint-disable-next-line no-console
    console.error('Database Error:', {
      code: error.code,
      message: error.message,
      details: error.details,
      hint: error.hint,
    });
  } else if (isDatabaseError(error)) {
    // eslint-disable-next-line no-console
    console.error('Database Error:', {
      code: error.code,
      message: error.message,
      details: error.details,
      hint: error.hint,
    });
  } else {
    // eslint-disable-next-line no-console
    console.error('Unknown Error:', error);
  }
}
